/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { Card, Row, Col, OverlayTrigger, Popover, Accordion, Button } from 'react-bootstrap';
import moment from 'moment';
import { isEqual, some } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import Loader from '../../../../Components/Utility/Loader/Loader';
import '../../SupplierSuggestion.css';
import { shortenStringWithTooltip } from '../../../../Components/helper';
import * as actions from '../../store/SupplierSuggestion.action';
import ConfirmationPopup from '../../../../Components/ModalPopup/ConfirmationPopup';
import DuplicateDeleteModal from '../../../../Components/ModalPopup/DuplicateDeleteModal';
import CustomToggle from '../../../../Components/CustomToggle';

function BomSuggestionCard({ match, suggestionData, updateData, approveReject, suggestionType, updatedSuggestionLibrary, approveRejectDisable }) {
  const dispatch = useDispatch();
  const autoApproved = '(Auto Approved)';
  const bomTransport = 'BOM.BOM_SUGGESTION_CARD.TRANSPORT';
  const bomQuality = 'BOM.BOM_SUGGESTION_CARD.QUALITY';
  const bomCompSubType = 'BOM.BOM_SUGGESTION_CARD.BOM_COMPONENT_SUB_TYPE';
  const bomFinished = 'BOM.BOM_SUGGESTION_CARD.FINISH';
  const bomLabelReducer = useSelector((reducerstate) => reducerstate);
  const { UserDetails, SupplierSuggestion } = bomLabelReducer;
  const { userInfo } = UserDetails;
  const { duplicateCodeModal, BOMComponent, supplierData } = SupplierSuggestion;

  const [loader, setLoader] = useState(false);
  const [showApproveRejectPopup, setShowApproveRejectPopup] = useState(false);

  const [approveRejectComment, setApproveRejectComment] = useState();
  const [selectedIdArray, setSelectedIdArray] = useState([]);
  const [confirmAction, setConfirmAction] = useState(false);
  const [oldSuggestion, setOldSuggestion] = useState([]);

  const [suggestionDataAsOriginal, setSuggestionDataAsOriginal] = useState([]);
  const [oldDataFound, setOldDataFound] = useState(suggestionType === 'new');
  const [checkBoxDisabled, setCheckBoxDisabled] = useState(false);
  const [subBomAccordionKeys, setSubBomAccordionKeys] = useState({});
  const [productImpactActiveKeys, setProductImpactActiveKeys] = useState({});

  const bomStatusApprovedClass = 'bom-status-approved';
  const approvedFromSupplierToDo = 'bom-approved-from-todo';
  const { t } = useTranslation('common');

  const fieldsArray = [
    'bomDescription',
    'BOMSupplier',
    'composition',
    'size',
    'weight',
    'quantity',
    'newPlacement',
    'additionalInfo',
    'transport',
    'bomComponentSubType',
    'quality',
    'finished',
    'dynamicColumn',
    'subBomList',
    'productImpact',
    'pricePerUnit',
  ];

  useEffect(() => {
    if (selectedIdArray.length || suggestionDataAsOriginal.length) {
      if (suggestionDataAsOriginal.length === 1) {
        setSelectedIdArray([{ _id: suggestionDataAsOriginal[0]?._id }]);
      } else {
        setSelectedIdArray([...selectedIdArray]);
      }
      setShowApproveRejectPopup(approveReject?.status);
      setConfirmAction(approveReject?.action);
    }
  }, [approveReject, suggestionDataAsOriginal]);

  useEffect(() => {
    if (selectedIdArray.length > 0) {
      approveRejectDisable(false);
    } else {
      approveRejectDisable(true);
    }
  }, [selectedIdArray]);

  const setExistingData = (id, newData, newUnit, name) => {
    switch (name) {
      case fieldsArray[0]: {
        let oldDesc;
        BOMComponent?.forEach((x) => {
          if (x._id === id) {
            if (isEqual(newData, x.bomDescription)) {
              oldDesc = false;
            } else {
              oldDesc = x.bomDescription === '' ? true : x.bomDescription;
            }
          }
        });
        return oldDesc;
      }
      case fieldsArray[1]: {
        let oldBOMSupplier;
        BOMComponent?.forEach((x) => {
          if (x._id === id) {
            if (isEqual(newData, x.BOMSupplier)) {
              oldBOMSupplier = false;
            } else {
              oldBOMSupplier = x.oldBOMSupplier === '' ? true : x.oldBOMSupplier;
            }
          }
        });
        return oldBOMSupplier;
      }
      case fieldsArray[2]: {
        let oldComposition;
        BOMComponent?.forEach((x) => {
          if (x._id === id) {
            const result = isEqual(JSON.stringify(x?.composition), JSON.stringify(newData));
            if (result) {
              oldComposition = false;
            } else {
              oldComposition =
                newData?.length !== x?.composition?.length ||
                (newData?.length && !x?.composition?.length) ||
                (!newData?.length && x?.composition?.length) ||
                !isEqual(JSON.stringify(x?.composition), JSON.stringify(newData))
                  ? true
                  : shortenStringWithTooltip(
                      x?.composition
                        .map((el) => (el?.percentage ? `${el.percentage}%  ${el?.composition?.name || ''}` : ''))
                        .sort((a, b) => b.percentage - a.percentage)
                        .join(', '),
                      20,
                    );
            }
          }
        });
        return oldComposition;
      }
      case fieldsArray[3]: {
        let oldSize;
        BOMComponent?.forEach((x) => {
          if (x._id === id) {
            if (isEqual(newData, x.size) && isEqual(newUnit, x.sizeUnitOfMeasure?.name)) {
              oldSize = false;
            } else {
              const sUnit = x?.sizeUnitOfMeasure?.name;
              if (sUnit) {
                oldSize = x.size === '' ? true : `${x.size} ${sUnit}`;
              } else {
                oldSize = x.size === '' ? true : `${x.size}`;
              }
            }
          }
        });
        return oldSize;
      }
      case fieldsArray[4]: {
        let oldWeight;
        BOMComponent?.forEach((x) => {
          if (x._id === id) {
            if (isEqual(newData, x.weight) && isEqual(newUnit, x.weightUnitOfMeasure?.name)) {
              oldWeight = false;
            } else {
              const wUnit = x?.weightUnitOfMeasure?.name;
              if (wUnit) {
                oldWeight = x.weight === '' ? true : `${x.weight} ${wUnit}`;
              } else {
                oldWeight = x.weight === '' ? true : `${x.weight}`;
              }
            }
          }
        });
        return oldWeight;
      }
      case fieldsArray[5]: {
        let oldQuantity;
        BOMComponent?.forEach((x) => {
          if (x._id === id) {
            if (isEqual(newData, x.quantity) && isEqual(newUnit, x.quantityUnitOfMeasure?.name)) {
              oldQuantity = false;
            } else {
              const qUnit = x?.quantityUnitOfMeasure?.name;
              if (qUnit) {
                oldQuantity = x.quantity === '' ? true : `${x.quantity} ${qUnit}`;
              } else {
                oldQuantity = x.quantity === '' ? true : `${x.quantity}`;
              }
            }
          }
        });
        return oldQuantity;
      }
      case fieldsArray[6]: {
        let oldPlacement;
        BOMComponent?.forEach((x) => {
          if (x._id === id) {
            const newDataIds = Array.isArray(newData)
              ? newData.map((item) => item.value).sort((a, b) => newData.findIndex((item) => item.value === a) - newData.findIndex((item) => item.value === b))
              : [];
            const existingPlacementIds = Array.isArray(x.newPlacement) ? x.newPlacement.map((item) => item._id || item.value).sort() : [];
            if (isEqual(newDataIds, existingPlacementIds)) {
              oldPlacement = false;
            } else {
              oldPlacement = x.newPlacement === undefined || x.newPlacement === null || x.newPlacement.length === 0 ? true : x.newPlacement;
            }
          }
        });
        return oldPlacement;
      }
      case fieldsArray[7]: {
        let oldAdditionalInfo;
        BOMComponent?.forEach((x) => {
          if (x._id === id) {
            if (isEqual(newData, x.additionalInfo)) {
              oldAdditionalInfo = false;
            } else {
              oldAdditionalInfo = x?.additionalInfo === '' ? true : x?.additionalInfo;
            }
          }
        });
        return oldAdditionalInfo;
      }
      case fieldsArray[8]: {
        let oldTransport;
        BOMComponent?.forEach((x) => {
          if (x._id === id) {
            if (isEqual(newData?._id, x.transport?._id)) {
              oldTransport = false;
            } else {
              oldTransport = x?.transport === null ? true : x?.transport;
            }
          }
        });
        return oldTransport;
      }
      case fieldsArray[9]: {
        let oldBomCompSubType;
        BOMComponent?.forEach((x) => {
          if (x._id === id) {
            if (isEqual(newData?._id, x?.bomComponentSubType?._id)) {
              oldBomCompSubType = false;
            } else {
              oldBomCompSubType = x?.bomComponentSubType === null ? true : x?.bomComponentSubType;
            }
          }
        });
        return oldBomCompSubType;
      }
      case fieldsArray[10]: {
        let oldQuality;
        BOMComponent?.forEach((x) => {
          if (x._id === id) {
            if (isEqual(newData?._id, x?.quality?._id)) {
              oldQuality = false;
            } else {
              oldQuality = x?.quality === null ? true : x?.quality;
            }
          }
        });
        return oldQuality;
      }
      case fieldsArray[11]: {
        let oldFinished;
        BOMComponent?.forEach((x) => {
          if (x._id === id) {
            if (isEqual(newData?._id, x?.finished?._id)) {
              oldFinished = false;
            } else {
              oldFinished = x?.finished === null ? true : x?.finished;
            }
          }
        });
        return oldFinished;
      }
      case fieldsArray[12]: {
        const changedDynamicColumns = [];

        // Helper function to extract value from dynamic column item based on type
        const extractColumnValue = (item) => {
          // Case 1: Multi Dropdown type - extract and sort IDs from valueId array
          if (item.colId?.type === 'Multi Dropdown') {
            if (Array.isArray(item.valueId)) {
              return item.valueId.map((v) => v._id).sort();
            }
            return [];
          }

          // Case 2: Regular dropdown type - extract single ID from valueId
          if (item.colId?.type === 'dropdown') {
            return item?.valueId?._id;
          }

          // Case 3: Default case - return text value
          return item?.valueText;
        };

        BOMComponent?.forEach((x) => {
          if (x._id === id) {
            const oldCols = Array.isArray(x?.dynamicColumn) ? x.dynamicColumn : [];
            const newCols = Array.isArray(newData) ? newData : [];
            const oldMap = new Map(oldCols.map((item) => [item.colId?._id || item.colId, item]));
            const newMap = new Map(newCols.map((item) => [item.colId?._id || item.colId, item]));
            newMap.forEach((newItem, colId) => {
              const oldItem = oldMap.get(colId);

              if (!oldItem) {
                changedDynamicColumns.push(newItem); // new entry
              } else {
                const oldVal = extractColumnValue(oldItem);
                const newVal = extractColumnValue(newItem);

                if (!isEqual(oldVal, newVal)) {
                  changedDynamicColumns.push(newItem);
                }
              }
            });
          }
        });

        return changedDynamicColumns.length > 0 ? changedDynamicColumns : false;
      }
      case fieldsArray[13]: {
        const changedSubBomList = [];
        const foundComponent = BOMComponent?.find((x) => x._id === id);

        if (!foundComponent) {
          if (newData && Array.isArray(newData) && newData.length > 0) {
            return newData.map((item, idx) => ({ item, changedFields: ['all'], originalIndex: idx }));
          }
          return false;
        }

        const oldSubBomList = foundComponent?.subBomList || [];
        const newSubBomList = newData || [];

        if (oldSubBomList.length === 0 && newSubBomList.length > 0) {
          return newSubBomList.map((item, idx) => ({ item, changedFields: ['all'], originalIndex: idx }));
        }

        if (newSubBomList.length === 0 && oldSubBomList.length > 0) {
          return true;
        }

        const getFieldValue = (item, fieldName) => {
          const fieldValueMap = {
            referenceCode: item?.referenceCode || '',
            bomDescription: item?.bomDescription || '',
            BOMSupplier: item?.BOMSupplier?._id || item?.BOMSupplier || '',
            bomComponentType: item?.bomComponentType?._id || item?.bomComponentType || '',
            bomComponentSubType: item?.bomComponentSubType?._id || item?.bomComponentSubType || '',
            size: item?.size || '',
            sizeUnitOfMeasure: item?.sizeUnitOfMeasure?._id || item?.sizeUnitOfMeasure || '',
            weight: item?.weight || '',
            weightUnitOfMeasure: item?.weightUnitOfMeasure?._id || item?.weightUnitOfMeasure || '',
            quantity: item?.quantity || '',
            quantityUnitOfMeasure: item?.quantityUnitOfMeasure?._id || item?.quantityUnitOfMeasure || '',
            pricePerUnit: item?.pricePerUnit || '',
            pricePerUnitCurrency:
              typeof item?.pricePerUnitCurrency === 'string'
                ? item?.pricePerUnitCurrency
                : item?.pricePerUnitCurrency?.value || item?.pricePerUnitCurrency?._id || '',
            finished: item?.finished?._id || item?.finished || '',
            composition: JSON.stringify(
              (item?.composition || [])
                .map((comp) => ({
                  percentage: comp?.percentage || '',
                  composition: comp?.composition?._id || comp?.composition || '',
                }))
                .sort((a, b) => {
                  const aPerc = parseFloat(a.percentage) || 0;
                  const bPerc = parseFloat(b.percentage) || 0;
                  return bPerc - aPerc;
                }),
            ),
          };
          return fieldValueMap[fieldName] ?? '';
        };

        const allFieldNames = [
          'referenceCode',
          'bomDescription',
          'BOMSupplier',
          'bomComponentType',
          'bomComponentSubType',
          'size',
          'sizeUnitOfMeasure',
          'weight',
          'weightUnitOfMeasure',
          'quantity',
          'quantityUnitOfMeasure',
          'pricePerUnit',
          'pricePerUnitCurrency',
          'finished',
          'composition',
        ];

        if (oldSubBomList.length !== newSubBomList.length) {
          return newSubBomList.length > 0 ? newSubBomList.map((item, idx) => ({ item, changedFields: ['all'], originalIndex: idx })) : true;
        }

        newSubBomList.forEach((newItem, index) => {
          const oldItem = oldSubBomList[index];
          if (!oldItem) {
            changedSubBomList.push({
              item: newItem,
              changedFields: ['all'],
              originalIndex: index,
            });
          } else {
            const changedFields = [];

            allFieldNames.forEach((fieldName) => {
              const oldValue = getFieldValue(oldItem, fieldName);
              const newValue = getFieldValue(newItem, fieldName);
              if (!isEqual(oldValue, newValue)) {
                changedFields.push(fieldName);
              }
            });

            if (changedFields.length > 0) {
              changedSubBomList.push({
                item: newItem,
                changedFields,
                originalIndex: index,
              });
            }
          }
        });

        if (changedSubBomList.length === 0 && oldSubBomList.length > 0 && newSubBomList.length > 0) {
          return false;
        }

        return changedSubBomList.length > 0 ? changedSubBomList : false;
      }
      case fieldsArray[14]: {
        const foundComponent = BOMComponent?.find((x) => x._id === id);
        if (!foundComponent) {
          if (newData) {
            return { changedFields: ['all'] };
          }
          return false;
        }

        const oldProductImpact = foundComponent?.productImpact || {};
        const newProductImpact = newData || {};
        const changedFields = [];

        const getFieldValue = (obj, path) => {
          const keys = path.split('.');
          let value = obj;
          for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            if (value === null || value === undefined) return null;

            if (i === keys.length - 1) {
              if (key === 'bomProcessType' || key === 'compositionProcessType') {
                return Array.isArray(value[key])
                  ? value[key]
                      .map((item) => item?._id || item)
                      .sort()
                      .join(',')
                  : null;
              }
              if (key === 'componentSupplier' || key === 'postProcessingSupp' || key === 'rawMaterialProcessor' || key === 'rawMaterialExtractor') {
                return value[key]?._id || value[key] || null;
              }
              if (key === 'transport') {
                return value[key]?._id || value[key]?.value || value[key] || null;
              }
            }
            value = value[key];
          }
          return value;
        };

        const productImpactFields = [
          'tierOne',
          'tierTwo.postProcessingAnotherLocation',
          'tierTwo.finishedProductAssemblySupp',
          'tierTwo.componentSupplierObj.componentSupplier',
          'tierTwo.componentSupplierObj.energySource',
          'tierTwo.componentSupplierObj.energyIntensity',
          'tierTwo.componentSupplierObj.transport',
          'tierTwo.componentSupplierObj.bomProcessType',
          'tierTwo.componentPostProcessing.postProcessingSupp',
          'tierTwo.componentPostProcessing.energySource',
          'tierTwo.componentPostProcessing.energyIntensity',
          'tierTwo.componentPostProcessing.transport',
          'tierTwo.componentPostProcessing.bomProcessType',
          'tierThree.rawMaterialProcessorExtractor',
          'tierThree.rawMaterialProcessor',
          'tierThree.energySource',
          'tierThree.energyIntensity',
          'tierThree.transport',
          'tierThree.bomProcessType',
          'tierFour.rawMaterialExtractor',
          'tierFour.energySource',
          'tierFour.energyIntensity',
          'tierFour.transport',
          'tierFour.compositionProcessType',
        ];

        productImpactFields.forEach((fieldPath) => {
          const oldValue = getFieldValue(oldProductImpact, fieldPath);
          const newValue = getFieldValue(newProductImpact, fieldPath);
          if (!isEqual(oldValue, newValue)) {
            changedFields.push(fieldPath);
          }
        });

        if (changedFields.length === 0) {
          return false;
        }

        return { changedFields };
      }
      case fieldsArray[15]: {
        let oldPricePerUnit = false;
        BOMComponent?.forEach((x) => {
          if (x._id === id) {
            const currencyName = typeof newUnit === 'string' ? newUnit : newUnit?.label || newUnit?.value || '';
            const oldCurrencyName =
              typeof x.pricePerUnitCurrency === 'string' ? x.pricePerUnitCurrency : x.pricePerUnitCurrency?.label || x.pricePerUnitCurrency?.value || '';
            if (isEqual(newData, x.pricePerUnit) && isEqual(currencyName, oldCurrencyName)) {
              oldPricePerUnit = false;
            } else {
              const pUnit = x.pricePerUnit === '' || x.pricePerUnit === null || x.pricePerUnit === undefined;
              if (oldCurrencyName) {
                oldPricePerUnit = pUnit ? true : `${x.pricePerUnit} ${oldCurrencyName}`;
              } else {
                oldPricePerUnit = pUnit ? true : `${x.pricePerUnit}`;
              }
            }
          }
        });
        return oldPricePerUnit;
      }

      default:
        break;
    }
  };

  const getHighlightedArr = () => {
    const data = [];
    suggestionDataAsOriginal.map((item) => {
      const obj = {
        id: item._id,
      };
      obj.bomDescription = setExistingData(item.bomLibId, item?.bomDescription, '', fieldsArray[0]);
      obj.composition = setExistingData(item.bomLibId, item?.composition, '', fieldsArray[2]);
      obj.size = setExistingData(item.bomLibId, item?.size, item?.sizeUnitOfMeasure?.name, fieldsArray[3]);
      obj.weight = setExistingData(item.bomLibId, item?.weight, item?.weightUnitOfMeasure?.name, fieldsArray[4]);
      obj.quantity = setExistingData(item.bomLibId, item?.quantity, item?.quantityUnitOfMeasure?.name, fieldsArray[5]);
      obj.newPlacement = setExistingData(item.bomLibId, item?.newPlacement, null, fieldsArray[6]);
      obj.additionalInfo = setExistingData(item.bomLibId, item?.additionalInfo, '', fieldsArray[7]);
      obj.transport = setExistingData(item.bomLibId, item?.transport, null, fieldsArray[8]);
      obj.bomComponentSubType = setExistingData(item.bomLibId, item?.bomComponentSubType, null, fieldsArray[9]);
      obj.quality = setExistingData(item.bomLibId, item?.quality, null, fieldsArray[10]);
      obj.finished = setExistingData(item.bomLibId, item?.finished, null, fieldsArray[11]);
      obj.dynamicColumn = setExistingData(item.bomLibId, item?.dynamicColumn, null, fieldsArray[12]);
      obj.subBomList = setExistingData(item.bomLibId, item?.subBomList, null, fieldsArray[13]);
      obj.productImpact = setExistingData(item.bomLibId, item?.productImpact, null, fieldsArray[14]);
      obj.pricePerUnit = setExistingData(item.bomLibId, item?.pricePerUnit, item?.pricePerUnitCurrency?.value || item?.pricePerUnitCurrency, fieldsArray[15]);

      data.push(obj);
    });

    const obj = {
      bomDescription: 'bomDescription',
      composition: 'composition',
      size: 'size',
      weight: 'weight',
      quantity: 'quantity',
      newPlacement: 'newPlacement',
      additionalInfo: 'additionalInfo',
      transport: 'transport',
      bomComponentSubType: 'bomComponentSubType',
      quality: 'quality',
      finished: 'finished',
      dynamicColumn: 'dynamicColumn',
      subBomList: 'subBomList',
      productImpact: 'productImpact',
      pricePerUnit: 'pricePerUnit',
    };

    const finalArray = [];
    data.forEach((dat) => {
      const arr = [];
      fieldsArray.forEach((jk) => {
        if (dat[jk]) {
          arr.push(obj[jk]);
        }
      });
      if (arr.length > 0) {
        finalArray.push({ id: dat.id, highlightedKeys: arr });
      }
    });
    return finalArray;
  };
  const handleApproveReject = async (action) => {
    setLoader(true);

    const getHighlightedValues = getHighlightedArr();
    const obj = {
      suggestionId: match?.params?.id,
      componentId: selectedIdArray,
      comment: approveRejectComment,
      section: 'bom',
      highlightedArr: getHighlightedValues,
    };
    if (confirmAction === 'Approved') obj.type = suggestionType;

    if (action && selectedIdArray.length) {
      const res = await dispatch(actions.approveRejectSuggestion(confirmAction, obj, t));
      if (res) {
        setShowApproveRejectPopup(false);
        updateData();
      }
    }
    setLoader(false);
  };

  const handleCommentChange = (e) => {
    setApproveRejectComment(e.target.value);
  };

  const setBomStatus = (item) => {
    switch (item.status) {
      case 'Approved':
        return <div className=" bom-approved" />;
      case 'Rejected':
        return <div className=" bom-rejected" />;
      case 'Deleted':
        return <div className=" bom-deleted" />;
      default:
        return <div className=" bom-pending " />;
    }
  };

  const getOldBomData = () => {
    const oldData = BOMComponent?.length > 0 && BOMComponent?.filter((elem) => suggestionData?.bomComponents?.find(({ _id }) => elem?._id === _id));
    setOldSuggestion(oldData);
    setOldDataFound(!oldDataFound);
  };

  // all useEffect collection
  useEffect(() => {
    if (suggestionType !== 'new') {
      getOldBomData();
    }
  }, []);

  useEffect(() => {
    if (oldDataFound) {
      const newBomLibrary =
        suggestionData?.bomComponents?.length > 0 &&
        suggestionData.bomComponents.map((item) => {
          const oldData = Array.isArray(oldSuggestion) && oldSuggestion.filter((e) => e._id === item._id);

          if (oldData?.length === 0 && suggestionType !== 'new' && item.status !== 'Approved') {
            return {
              ...item,
              status: 'Deleted',
            };
          }
          return {
            ...item,
          };
        });
      setSuggestionDataAsOriginal(newBomLibrary);
      if (newBomLibrary) {
        allTypesStatusLengthCheck(newBomLibrary);
      }
    }
  }, [oldSuggestion, oldDataFound]);

  const allTypesStatusLengthCheck = (array) => {
    let totalBomApproved = 0;
    let totalBomPending = 0;
    let totalBomRejected = 0;

    totalBomApproved = array.filter((item) => item.status === 'Approved').length;

    totalBomPending = array.filter((item) => item.status === 'Pending' || item.status === 'pending').length;

    totalBomRejected = array.filter((item) => item.status === 'Rejected').length;

    if (totalBomApproved && totalBomPending === 1 && totalBomRejected === 0) {
      const id = array.filter((item) => item.status === 'Pending' || item.status === 'pending')[0]._id;
      setSelectedIdArray([{ _id: id }]);
      setCheckBoxDisabled(true);
    }

    if (totalBomApproved && totalBomPending === 0 && totalBomRejected === 1) {
      const id = array.filter((item) => item.status === 'Rejected')[0]._id;
      setSelectedIdArray([{ _id: id }]);
      setCheckBoxDisabled(true);
    }
  };

  useEffect(() => {
    updatedSuggestionLibrary(suggestionDataAsOriginal);
  }, [suggestionDataAsOriginal]);

  useEffect(() => {
    if (suggestionDataAsOriginal && suggestionDataAsOriginal.length > 0) {
      setSubBomAccordionKeys((prev) => {
        const updatedKeys = { ...prev };
        suggestionDataAsOriginal.forEach((item) => {
          const originalKey = `original-${item._id}`;
          const suggestionKey = `suggestion-${item._id}`;
          if (item?.originalItem?.subBomList && item.originalItem.subBomList.length > 0 && updatedKeys[originalKey] === undefined) {
            updatedKeys[originalKey] = '0';
          }
          if (item?.subBomList && item.subBomList.length > 0 && updatedKeys[suggestionKey] === undefined) {
            updatedKeys[suggestionKey] = '0';
          }
        });
        if (oldSuggestion && oldSuggestion.length > 0) {
          oldSuggestion.forEach((oldItem) => {
            const oldKey = `old-${oldItem._id}`;
            if (oldItem?.subBomList && oldItem.subBomList.length > 0 && updatedKeys[oldKey] === undefined) {
              updatedKeys[oldKey] = '0';
            }
          });
        }
        return updatedKeys;
      });
      setProductImpactActiveKeys((prev) => {
        const updatedKeys = { ...prev };
        suggestionDataAsOriginal.forEach((item) => {
          const originalKey = `original-${item._id}`;
          const suggestionKey = `suggestion-${item._id}`;
          if (item?.originalItem?.productImpact && updatedKeys[originalKey] === undefined) {
            updatedKeys[originalKey] = '0';
          }
          if (item?.productImpact && updatedKeys[suggestionKey] === undefined) {
            updatedKeys[suggestionKey] = '0';
          }
        });
        if (oldSuggestion && oldSuggestion.length > 0) {
          oldSuggestion.forEach((oldItem) => {
            const oldKey = `old-${oldItem._id}`;
            if (oldItem?.productImpact && updatedKeys[oldKey] === undefined) {
              updatedKeys[oldKey] = '0';
            }
          });
        }
        return updatedKeys;
      });
    }
    if (suggestionType === 'new' && suggestionData?.bomComponents && suggestionData.bomComponents.length > 0) {
      setSubBomAccordionKeys((prev) => {
        const updatedKeys = { ...prev };
        suggestionData?.bomComponents?.forEach((item) => {
          const newKey = `new-${item._id}`;
          if (item?.subBomList && item.subBomList.length > 0 && updatedKeys[newKey] === undefined) {
            updatedKeys[newKey] = '0';
          }
        });
        return updatedKeys;
      });
      setProductImpactActiveKeys((prev) => {
        const updatedKeys = { ...prev };
        suggestionData?.bomComponents?.forEach((item) => {
          const newKey = `new-${item._id}`;
          if (item?.productImpact && updatedKeys[newKey] === undefined) {
            updatedKeys[newKey] = '0';
          }
        });
        return updatedKeys;
      });
    }
  }, [suggestionDataAsOriginal, oldSuggestion, suggestionType, suggestionData]);

  const onCheck = async (_e, id) => {
    const selectedItemsIds = [...selectedIdArray];
    if (!some(selectedItemsIds, { _id: id })) {
      selectedItemsIds.push({ _id: id });
    } else {
      const tmpIndex = selectedItemsIds.map((idObj) => idObj._id).indexOf(id);
      selectedItemsIds.splice(tmpIndex, 1);
    }
    setSelectedIdArray([...selectedItemsIds]);
  };

  const closeDuplicateDeleteModal = () => {
    dispatch(actions.setDuplicateCodeModal(false, null));
  };

  const approvedStatus = (isComposition) => {
    return isComposition ? bomStatusApprovedClass : '';
  };

  const renderSubBomListTable = (subBomList, isChanged = false, itemStatus = null, changedSubBomItems = []) => {
    if (!subBomList || subBomList.length === 0) {
      return null;
    }

    const getChangedFieldsForItem = (subBomItem, index) => {
      if (!isChanged || !Array.isArray(changedSubBomItems) || changedSubBomItems.length === 0) {
        return [];
      }
      const changedItemByIndex = changedSubBomItems.find((changed) => {
        const originalIdx = changed?.originalIndex;
        return originalIdx !== undefined && originalIdx === index;
      });
      if (changedItemByIndex?.changedFields) {
        if (changedItemByIndex.changedFields.includes('all')) {
          return [
            'referenceCode',
            'bomDescription',
            'BOMSupplier',
            'bomComponentType',
            'bomComponentSubType',
            'size',
            'sizeUnitOfMeasure',
            'weight',
            'weightUnitOfMeasure',
            'quantity',
            'quantityUnitOfMeasure',
            'pricePerUnit',
            'pricePerUnitCurrency',
            'finished',
            'composition',
          ];
        }
        return changedItemByIndex.changedFields;
      }

      const changedItem = changedSubBomItems.find((changed) => {
        const changedItemData = changed?.item || changed;
        const changedRefCode = changedItemData?.referenceCode;
        const changedId = changedItemData?._id;
        const currentRefCode = subBomItem?.referenceCode;
        const currentId = subBomItem?._id;
        if (changedRefCode && currentRefCode) {
          const changedRefCodeNormalized = String(changedRefCode).trim().toLowerCase();
          const currentRefCodeNormalized = String(currentRefCode).trim().toLowerCase();
          if (changedRefCodeNormalized === currentRefCodeNormalized) {
            return true;
          }
        }

        if (changedId && currentId) {
          const changedIdStr = String(changedId);
          const currentIdStr = String(currentId);
          if (changedIdStr === currentIdStr) {
            return true;
          }
        }
        return false;
      });

      if (changedItem?.changedFields) {
        if (changedItem.changedFields.includes('all')) {
          return [
            'referenceCode',
            'bomDescription',
            'BOMSupplier',
            'bomComponentType',
            'bomComponentSubType',
            'size',
            'sizeUnitOfMeasure',
            'weight',
            'weightUnitOfMeasure',
            'quantity',
            'quantityUnitOfMeasure',
            'pricePerUnit',
            'pricePerUnitCurrency',
            'finished',
            'composition',
          ];
        }
        return changedItem.changedFields;
      }
      return [];
    };
    const getFieldClassName = (subBomItem, fieldName, index) => {
      const changedFields = getChangedFieldsForItem(subBomItem, index);
      if (changedFields.length === 0) return '';
      const isFieldChanged = changedFields.includes(fieldName);
      if (!isFieldChanged) return '';
      if (itemStatus === 'Approved') {
        return approvedFromSupplierToDo;
      }
      return bomStatusApprovedClass;
    };

    return (
      <div className="mt-2">
        {subBomList.map((subBomItem, index) => {
          const supplierName =
            subBomItem?.BOMSupplier?.name ||
            subBomItem?.BOMSupplier?.companies?.[0]?.supplierName ||
            subBomItem?.BOMSupplier?.companies?.[0]?.companyName ||
            '';
          const componentTypeName = subBomItem?.bomComponentType?.name || '';
          const componentSubTypeName = subBomItem?.bomComponentSubType?.name || '';
          const sizeUOM = subBomItem?.sizeUnitOfMeasure?.name || '';
          const weightUOM = subBomItem?.weightUnitOfMeasure?.name || '';
          const quantityUOM = subBomItem?.quantityUnitOfMeasure?.name || '';
          const pricePerUnitCurrency =
            typeof subBomItem?.pricePerUnitCurrency === 'string'
              ? subBomItem?.pricePerUnitCurrency
              : subBomItem?.pricePerUnitCurrency?.label || subBomItem?.pricePerUnitCurrency?.value || '';
          const finishedName = subBomItem?.finished?.name || '';
          const compositionText =
            subBomItem?.composition
              ?.map((comp) => {
                const compName = comp?.composition?.name || '';
                const percentage = comp?.percentage || '';
                return percentage && compName ? `${percentage}% ${compName}` : '';
              })
              .filter(Boolean)
              .sort((a, b) => {
                const aPerc = parseFloat(a.split('%')[0]) || 0;
                const bPerc = parseFloat(b.split('%')[0]) || 0;
                return bPerc - aPerc;
              })
              .join(', ') || '';

          return (
            <ul key={subBomItem?._id || index} className="suggestion-item">
              <li>
                <strong>{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPONENT_CODE')}&nbsp;</strong>
                <span className={getFieldClassName(subBomItem, 'referenceCode', index)}>{subBomItem?.referenceCode || ''}</span>
              </li>
              <li>
                <strong>{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPONENT_SUPLIER')}&nbsp;</strong>
                <span className={getFieldClassName(subBomItem, 'BOMSupplier', index)}>{supplierName}</span>
              </li>
              <li>
                <strong>{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPONENT_SUB_TYPE')}&nbsp;</strong>
                <span className={getFieldClassName(subBomItem, 'bomComponentSubType', index)}>{componentSubTypeName}</span>
              </li>
              <li>
                <strong>{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.WEIGHT/UOM')}&nbsp;</strong>
                <span className={getFieldClassName(subBomItem, 'weight', index) || getFieldClassName(subBomItem, 'weightUnitOfMeasure', index)}>
                  {subBomItem?.weight || ''} {weightUOM}
                </span>
              </li>
              <li>
                <strong>{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.FINISH')}&nbsp;</strong>
                <span className={getFieldClassName(subBomItem, 'finished', index)}>{finishedName}</span>
              </li>
              <li>
                <strong>{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPONENT_DESCRIPTION')}&nbsp;</strong>
                <span className={getFieldClassName(subBomItem, 'bomDescription', index)}>{subBomItem?.bomDescription || ''}</span>
              </li>
              <li>
                <strong>{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPONENT_TYPE')}&nbsp;</strong>
                <span className={getFieldClassName(subBomItem, 'bomComponentType', index)}>{componentTypeName}</span>
              </li>
              <li>
                <strong>{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.SIZE/UOM')}&nbsp;</strong>
                <span className={getFieldClassName(subBomItem, 'size', index) || getFieldClassName(subBomItem, 'sizeUnitOfMeasure', index)}>
                  {subBomItem?.size || ''} {sizeUOM}
                </span>
              </li>
              <li>
                <strong>{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.QUANTITY/UOM')}&nbsp;</strong>
                <span className={getFieldClassName(subBomItem, 'quantity', index) || getFieldClassName(subBomItem, 'quantityUnitOfMeasure', index)}>
                  {subBomItem?.quantity || ''} {quantityUOM}
                </span>
              </li>
              <li>
                <strong>{t('BOM.BOM_SUGGESTION_CARD.PRICE_PER_UNIT')}&nbsp;</strong>
                <span className={getFieldClassName(subBomItem, 'pricePerUnit', index) || getFieldClassName(subBomItem, 'pricePerUnitCurrency', index)}>
                  {subBomItem?.pricePerUnit || ''} {pricePerUnitCurrency}
                </span>
              </li>
              <li>
                <strong>{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPOSITION')}&nbsp;</strong>
                <span className={getFieldClassName(subBomItem, 'composition', index)}>{shortenStringWithTooltip(compositionText, 30)}</span>
              </li>
            </ul>
          );
        })}
      </div>
    );
  };

  const renderProductImpact = (productImpact, isChanged = false, itemStatus = null, changedProductImpactFields = {}) => {
    if (!productImpact) {
      return (
        <div className="text-center py-4">
          <p>{t('ERROR_MESSAGES.NO_DATA_AVAILABLE')}</p>
        </div>
      );
    }

    const getFieldClassName = (fieldName) => {
      if (!isChanged || !changedProductImpactFields?.changedFields) return '';
      const { changedFields } = changedProductImpactFields;
      if (changedFields.includes('all') || changedFields.includes(fieldName)) {
        if (itemStatus === 'Approved') {
          return approvedFromSupplierToDo;
        }
        return 'bom-impact-status-pending';
      }
      return '';
    };

    return (
      <div className="product-impact-container">
        {productImpact?.tierOne && (
          <div className="mb-4">
            <div className="highlight-form mb-0 common-input-control">
              <p className="f-18 h-20 mb-0 font-weight-bold">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.SELECT_TIER_ONE')}</p>
              <input
                type="text"
                name="tierOne"
                readOnly
                value={productImpact?.tierOne ? supplierData?.find((supp) => supp._id === productImpact.tierOne)?.name || '-' : '-'}
                className={`form-control ${getFieldClassName('tierOne')}`}
              />
            </div>
          </div>
        )}
        {productImpact?.tierTwo && (
          <div className="mb-3 tier-two-section">
            <h6 className="mb-0 font-weight-bold">{t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.TIER_TWO')}</h6>
            <div className="mb-3">
              <p className="mb-0">
                {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.POST_PROCESSING_SENTENCE')}
                <span className="ml-2">{productImpact.tierTwo.postProcessingAnotherLocation === 'yes' ? t('COMMON_LABEL.YES') : t('COMMON_LABEL.NO')}</span>
              </p>
            </div>

            {productImpact.tierTwo.postProcessingAnotherLocation === 'yes' && (
              <div className="mb-3">
                <p className="mb-2">
                  {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.POST_PROCESSING_GOODS_SENTENCE')}
                  <span className="ml-2">
                    {productImpact.tierTwo.finishedProductAssemblySupp === 'finishedProductAssemblySupplier'
                      ? t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.FINSIH_PRODUCT_ASSEMBLY')
                      : t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.COMPOENENT_SUPPLIER')}
                  </span>
                </p>
              </div>
            )}

            {productImpact.tierTwo.componentSupplierObj && (
              <div className="row mb-3">
                <div className="col-md-6">
                  <div className="highlight-form mb-0 common-input-control">
                    <p className="f-16 mb-0 h-20 text-bold">
                      {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.COMPOENENT_SUPPLIER')} <span className="asterisk">*</span>
                    </p>
                    <input
                      type="text"
                      name="componentSupplier"
                      readOnly
                      value={productImpact?.tierTwo?.componentSupplierObj?.componentSupplier?.firstName || '-'}
                      className={`form-control ${getFieldClassName('tierTwo.componentSupplierObj.componentSupplier')}`}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="highlight-form mb-0 common-input-control">
                    <p className="f-16 mb-0 h-20 text-bold">
                      {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.ENERGY_SOURCE')} <span className="asterisk">*</span>
                    </p>
                    <input
                      type="text"
                      name="energySource"
                      readOnly
                      value={productImpact?.tierTwo?.componentSupplierObj?.energySource || '-'}
                      className={`form-control ${getFieldClassName('tierTwo.componentSupplierObj.energySource')}`}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="highlight-form mb-0 common-input-control">
                    <p className="f-16 mb-0 h-20 text-bold">
                      {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.ENERGY_INTENSITY')} <span className="asterisk">*</span>
                    </p>
                    <input
                      type="text"
                      name="energyIntensity"
                      readOnly
                      value={productImpact?.tierTwo?.componentSupplierObj?.energyIntensity || '-'}
                      className={`form-control ${getFieldClassName('tierTwo.componentSupplierObj.energyIntensity')}`}
                    />
                  </div>
                </div>
              </div>
            )}

            <div className="row mb-3">
              <div className="col-md-6">
                <div className="highlight-form mb-0 common-input-control">
                  <p className="f-16 mb-0 h-20 text-bold">
                    {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.TRASPORT_POST_PROCESSING_SUPPLIER')} <span className="asterisk">*</span>
                  </p>
                  <input
                    type="text"
                    name="transport"
                    readOnly
                    value={
                      productImpact?.tierTwo?.componentSupplierObj?.transport?.name || productImpact?.tierTwo?.componentSupplierObj?.transport?.label || '-'
                    }
                    className={`form-control ${getFieldClassName('tierTwo.componentSupplierObj.transport')}`}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="highlight-form mb-0 common-input-control">
                  <p className="f-16 mb-0 h-20 text-bold">
                    {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.PROCESSES')} <span className="asterisk">*</span>
                  </p>
                  <input
                    type="text"
                    name="bomProcessType"
                    readOnly
                    value={productImpact?.tierTwo?.componentSupplierObj?.bomProcessType?.map((item) => item.name).join(', ') || '-'}
                    className={`form-control ${getFieldClassName('tierTwo.componentSupplierObj.bomProcessType')}`}
                  />
                </div>
              </div>
            </div>

            {productImpact.tierTwo.componentPostProcessing && (
              <div className="row mb-3">
                <div className="col-md-6">
                  <div className="highlight-form mb-0 common-input-control">
                    <p className="f-16 mb-0 h-20 text-bold">
                      {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.POST_PROCESSING_SUPPLIER')} <span className="asterisk">*</span>
                    </p>
                    <input
                      type="text"
                      name="postProcessingSupp"
                      readOnly
                      value={productImpact?.tierTwo?.componentPostProcessing?.postProcessingSupp?.firstName || '-'}
                      className={`form-control ${getFieldClassName('tierTwo.componentPostProcessing.postProcessingSupp')}`}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="highlight-form mb-0 common-input-control">
                    <p className="f-16 mb-0 h-20 text-bold">
                      {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.ENERGY_SOURCE')} <span className="asterisk">*</span>
                    </p>
                    <input
                      type="text"
                      name="energySource"
                      readOnly
                      value={productImpact?.tierTwo?.componentPostProcessing?.energySource || '-'}
                      className={`form-control ${getFieldClassName('tierTwo.componentPostProcessing.energySource')}`}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="highlight-form mb-0 common-input-control">
                    <p className="f-16 mb-0 h-20 text-bold">
                      {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.ENERGY_INTENSITY')} <span className="asterisk">*</span>
                    </p>
                    <input
                      type="text"
                      name="energyIntensity"
                      readOnly
                      value={productImpact?.tierTwo?.componentPostProcessing?.energyIntensity || '-'}
                      className={`form-control ${getFieldClassName('tierTwo.componentPostProcessing.energyIntensity')}`}
                    />
                  </div>
                </div>
              </div>
            )}

            <div className="row mb-3">
              <div className="col-md-6">
                <div className="highlight-form mb-0 common-input-control">
                  <p className="f-16 mb-0 h-20 text-bold">
                    {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.TRASPORT_POST_PROCESSING_SUPPLIER')} <span className="asterisk">*</span>
                  </p>
                  <input
                    type="text"
                    name="transport"
                    readOnly
                    value={
                      productImpact?.tierTwo?.componentPostProcessing?.transport?.name ||
                      productImpact?.tierTwo?.componentPostProcessing?.transport?.label ||
                      '-'
                    }
                    className={`form-control ${getFieldClassName('tierTwo.componentPostProcessing.transport')}`}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="highlight-form mb-0 common-input-control">
                  <p className="f-16 mb-0 h-20 text-bold">
                    {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.PROCESSES')} <span className="asterisk">*</span>
                  </p>
                  <input
                    type="text"
                    name="bomProcessType"
                    readOnly
                    value={productImpact?.tierTwo?.componentPostProcessing?.bomProcessType?.map((item) => item.name).join(', ') || '-'}
                    className={`form-control ${getFieldClassName('tierTwo.componentPostProcessing.bomProcessType')}`}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
        {productImpact?.tierThree && (
          <div className="mb-4 tier-three-section">
            <h6 className="mb-0 font-weight-bold">{t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.TIER_THRE')}</h6>
            <div className="mb-3">
              <p className="mb-0">
                {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.RAW_MATERIAL_EXTRACTORE')}
                <span className="ml-2">{productImpact?.tierThree?.rawMaterialProcessorExtractor === 'yes' ? t('COMMON_LABEL.YES') : t('COMMON_LABEL.NO')}</span>
              </p>
            </div>

            {productImpact?.tierThree?.rawMaterialProcessor && (
              <div className="row mb-3">
                <div className="col-md-6">
                  <div className="highlight-form mb-0 common-input-control">
                    <p className="f-16 mb-0 h-20 text-bold">
                      {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.RAW_MATERIAL_PROCESSOR')} <span className="asterisk">*</span>
                    </p>
                    <input
                      type="text"
                      name="rawMaterialProcessor"
                      readOnly
                      value={productImpact?.tierThree?.rawMaterialProcessor?.firstName || '-'}
                      className={`form-control ${getFieldClassName('tierThree.rawMaterialProcessor')}`}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="highlight-form mb-0 common-input-control">
                    <p className="f-16 mb-0 h-20 text-bold">
                      {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.ENERGY_SOURCE')} <span className="asterisk">*</span>
                    </p>
                    <input
                      type="text"
                      name="energySource"
                      readOnly
                      value={productImpact?.tierThree?.energySource || '-'}
                      className={`form-control ${getFieldClassName('tierThree.energySource')}`}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="highlight-form mb-0 common-input-control">
                    <p className="f-16 mb-0 h-20 text-bold">
                      {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.ENERGY_INTENSITY')} <span className="asterisk">*</span>
                    </p>
                    <input
                      type="text"
                      name="energyIntensity"
                      readOnly
                      value={productImpact?.tierThree?.energyIntensity || '-'}
                      className={`form-control ${getFieldClassName('tierThree.energyIntensity')}`}
                    />
                  </div>
                </div>
              </div>
            )}

            {productImpact.tierThree.transport && (
              <div className="row mb-3">
                <div className="col-md-6">
                  <div className="highlight-form mb-0 common-input-control">
                    <p className="f-16 mb-0 h-20 text-bold">
                      {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.TRASPORT_POST_PROCESSING_SUPPLIER')} <span className="asterisk">*</span>
                    </p>
                    <input
                      type="text"
                      name="transport"
                      readOnly
                      value={productImpact?.tierThree?.transport?.name || productImpact?.tierThree?.transport?.label || '-'}
                      className={`form-control ${getFieldClassName('tierThree.transport')}`}
                    />
                  </div>
                </div>
              </div>
            )}
            {productImpact?.tierThree?.rawMaterialProcessorExtractor === 'no' && productImpact?.tierFour?.rawMaterialExtractor && (
              <div className="row mb-3">
                <div className="col-md-6">
                  <div className="highlight-form mb-0 common-input-control">
                    <p className="f-16 mb-0 h-20 text-bold">
                      {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.RAW_MATERIA_EXTRACTOR')} <span className="asterisk">*</span>
                    </p>
                    <input
                      type="text"
                      name="rawMaterialExtractor"
                      readOnly
                      value={productImpact?.tierFour?.rawMaterialExtractor?.firstName || '-'}
                      className={`form-control ${getFieldClassName('tierFour.rawMaterialExtractor')}`}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="highlight-form mb-0 common-input-control">
                    <p className="f-16 mb-0 h-20 text-bold">
                      {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.ENERGY_SOURCE')} <span className="asterisk">*</span>
                    </p>
                    <input
                      type="text"
                      name="energySource"
                      readOnly
                      value={productImpact?.tierFour?.energySource || '-'}
                      className={`form-control ${getFieldClassName('tierFour.energySource')}`}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="highlight-form mb-0 common-input-control">
                    <p className="f-16 mb-0 h-20 text-bold">
                      {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.ENERGY_INTENSITY')} <span className="asterisk">*</span>
                    </p>
                    <input
                      type="text"
                      name="energyIntensity"
                      readOnly
                      value={productImpact?.tierFour?.energyIntensity || '-'}
                      className={`form-control ${getFieldClassName('tierFour.energyIntensity')}`}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {productImpact?.tierFour && (
          <div className="mb-3 tier-three-section">
            <h6 className="mb-3 font-weight-bold">{t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.TIER_FOUR')}</h6>

            <div className="row mb-3">
              <div className="col-md-6">
                <div className="highlight-form mb-0 common-input-control">
                  <p className="field-name text-bold">
                    {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.RAW_MATERIAL_PROCESSOR')} <span className="asterisk">*</span>
                  </p>
                  <input
                    type="text"
                    name="rawMaterialExtractor"
                    readOnly
                    value={productImpact?.tierFour?.rawMaterialExtractor?.firstName || '-'}
                    className={`form-control ${getFieldClassName('tierFour.rawMaterialExtractor')}`}
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="highlight-form mb-0 common-input-control">
                  <p className="f-16 mb-0 h-20 text-bold">
                    {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.ENERGY_SOURCE')} <span className="asterisk">*</span>
                  </p>
                  <input
                    type="text"
                    name="energySource"
                    readOnly
                    value={productImpact?.tierFour?.energySource || '-'}
                    className={`form-control ${getFieldClassName('tierFour.energySource')}`}
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="highlight-form mb-0 common-input-control">
                  <p className="f-16 mb-0 h-20 text-bold">
                    {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.ENERGY_INTENSITY')} <span className="asterisk">*</span>
                  </p>
                  <input
                    type="text"
                    name="energyIntensity"
                    readOnly
                    value={productImpact?.tierFour?.energyIntensity || '-'}
                    className={`form-control ${getFieldClassName('tierFour.energyIntensity')}`}
                  />
                </div>
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-6">
                <div className="highlight-form mb-0 common-input-control">
                  <p className="f-16 mb-0 h-20 text-bold">
                    {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.TRASPORT_POST_PROCESSING_SUPPLIER')} <span className="asterisk">*</span>
                  </p>
                  <input
                    type="text"
                    name="transport"
                    readOnly
                    value={productImpact?.tierFour?.transport?.name || productImpact?.tierFour?.transport?.label || '-'}
                    className={`form-control ${getFieldClassName('tierFour.transport')}`}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="highlight-form mb-0 common-input-control">
                  <p className="f-16 mb-0 h-20 text-bold">
                    {t('BOM_LIBRARY.BOM_PRODUCT_IMPACT.PROCESSES')} <span className="asterisk">*</span>
                  </p>
                  <input
                    type="text"
                    name="compositionProcessType"
                    readOnly
                    value={productImpact?.tierFour?.compositionProcessType?.map((item) => item.name).join(', ') || '-'}
                    className={`form-control ${getFieldClassName('tierFour.compositionProcessType')}`}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  const rejectedTitle = confirmAction === 'Rejected' ? t('SUPPLIER_SUGGESTION.CONFIRM.TITLE_REJECT') : '';
  const rejectedMessage = confirmAction === 'Rejected' ? t('SUPPLIER_SUGGESTION.CONFIRM.DELETE_MESSAGE_REJECT') : '';

  return (
    <>
      <div>
        {loader ? (
          <Loader />
        ) : (
          <div>
            {/* new card */}
            {suggestionType === 'new' && (
              <Row>
                {suggestionData?.bomComponents?.length > 0 &&
                  suggestionData?.bomComponents?.map((item, i) => {
                    return (
                      <Col key={item?._id} md={6}>
                        <Card className="rounded-0 mb-2 card-bordered">
                          <Card.Header className="py-2 px-3">
                            <div className="d-flex align-items-center">
                              {userInfo.role !== 'Supplier' && (item.status === 'Pending' || item.status === 'Rejected') && (
                                <div className="cus-chk-block" style={{ width: '30px' }}>
                                  <input
                                    onChange={(e) => {
                                      onCheck(e, item._id);
                                    }}
                                    name={`check_${i}`}
                                    id={`check_${i}`}
                                    type="checkbox"
                                    disabled={checkBoxDisabled}
                                    checked={some(selectedIdArray, {
                                      _id: item?._id,
                                    })}
                                  />
                                  <label htmlFor={`check_${i}`} className="cus-chklabel" />
                                </div>
                              )}
                              <div>{t('BOM.BOM_SUGGESTION_CARD.NEW_SUGGESTION')}</div>
                            </div>
                          </Card.Header>
                          <Card.Body className="py-2 px-3">
                            <ul className="suggestion-item">
                              <li>
                                <strong>{t('BOM.BOM_SUGGESTION_CARD.COMPONENT_CODES')}&nbsp;</strong>
                                {item?.referenceCode}
                              </li>
                              <li className="col-6">
                                <strong>{t('BOM.BOM_SUGGESTION_CARD.COMPONENT_TYPES')}&nbsp;</strong>
                                {item.bomSubType?.name}
                              </li>

                              <li className="col-6">
                                <strong>{t('BOM.BOM_SUGGESTION_CARD.DESCRIPTION')}:&nbsp;</strong>
                                <span>{item?.bomDescription}</span>
                              </li>

                              <li className="col-6">
                                <strong>{t('BOM.BOM_SUGGESTION_CARD.COMPONENT_SUPLIERS')}&nbsp;</strong>
                                <span>{item?.BOMSupplier.name}</span>
                              </li>

                              <li>
                                <strong>{t('BOM.BOM_SUGGESTION_CARD.SIZES')}&nbsp;</strong>
                                <span>
                                  {item?.size} {item?.sizeUnitOfMeasure?.name}
                                </span>
                              </li>
                              <li>
                                <strong>{t('BOM.BOM_SUGGESTION_CARD.WEIGHTS')}&nbsp;</strong>
                                <span>
                                  {item?.weight} {item?.weightUnitOfMeasure?.name}
                                </span>
                              </li>
                              {/* <li>
                                <strong>{t("BOM.BOM_SUGGESTION_CARD.QUANTITIES")}&nbsp;</strong>
                                <span>
                                  {item?.quantity} {item?.quantityUnitOfMeasure?.name}
                                </span>
                              </li> */}
                              <li>
                                <strong>{t('BOM.BOM_SUGGESTION_CARD.PRICE_PER_UNIT')}&nbsp;</strong>
                                <span>
                                  {item?.pricePerUnit || ''}{' '}
                                  {typeof item?.pricePerUnitCurrency === 'string'
                                    ? item?.pricePerUnitCurrency
                                    : item?.pricePerUnitCurrency?.label || item?.pricePerUnitCurrency?.value || ''}
                                </span>
                              </li>

                              <li className="col-6">
                                <strong>{t('BOM.BOM_SUGGESTION_CARD.PLACEMENTS')}&nbsp;</strong>
                                <span>{item?.newPlacement?.map((items) => items.name)?.join(', ')}</span>
                              </li>
                              <li>
                                <strong>{`${t(bomTransport)}:`}&nbsp;</strong>
                                <span>{item?.transport?.label}</span>
                              </li>
                              <li>
                                <strong>{`${t(bomQuality)}:`}&nbsp;</strong>
                                <span>{item?.quality?.label}</span>
                              </li>
                              <li>
                                <strong>{`${t(bomCompSubType)}:`}&nbsp;</strong>
                                <span>{item?.bomComponentSubType?.name}</span>
                              </li>
                              <li>
                                <strong>{`${t(bomFinished)}:`}&nbsp;</strong>
                                <span>{item?.finished?.name}</span>
                              </li>
                              <li className="col-6">
                                <strong>{t('BOM.BOM_SUGGESTION_CARD.COMPOSITIONS')}&nbsp;</strong>
                                <span>
                                  {item?.composition
                                    .map((el1) => (el1?.percentage > 0 ? `${el1?.percentage}% ${el1?.composition?.name}` : ''))
                                    .sort((a, b) => b.percentage - a.percentage)
                                    .join(', ')}
                                </span>
                              </li>
                              <li className="col-6">
                                <strong>{t('BOM.BOM_SUGGESTION_CARD.ADDITIONAL_INFOS')}&nbsp;</strong>
                                <span>{item?.additionalInfo}</span>
                              </li>
                              {item?.dynamicColumn
                                ?.filter((dynamicItem) => dynamicItem?.colId?.isActive !== false)
                                .map((dynamicItem, index) => {
                                  const keyName = dynamicItem?.colId?.keyName;
                                  const type = dynamicItem?.colId?.type;
                                  const colId = dynamicItem?.colId?._id;

                                  let value;
                                  if (type === 'Multi Dropdown') {
                                    value = Array.isArray(dynamicItem?.valueId) ? dynamicItem.valueId.map((v) => v?.keyName).join(', ') : '';
                                  } else if (type === 'dropdown') {
                                    value = dynamicItem?.valueId?.keyName || '';
                                  } else {
                                    value = dynamicItem?.valueText || '';
                                  }

                                  return (
                                    <li key={index}>
                                      <strong>{keyName}: </strong>
                                      <span>{value}</span>
                                    </li>
                                  );
                                })}
                              <li className={suggestionData?.bomComponents.length === 1 ? 'col-12 li-half' : 'col-12 li-full'}>
                                <strong>{t('BOM.BOM_SUGGESTION_CARD.STATUS')}:&nbsp;</strong>
                                <span>
                                  {item.status === 'Deleted' ? (
                                    "Original Entry doesn't exist"
                                  ) : (
                                    <span className="text-capitalize">
                                      {' '}
                                      {item.status === 'Pending' && item.status}
                                      {item.status !== 'Pending' && (
                                        <>
                                          <span className="mr-2">{item.status}</span>
                                          <OverlayTrigger
                                            placement="bottom"
                                            trigger="hover"
                                            rootClose
                                            overlay={
                                              <Popover className="custom-popover modified-popover">
                                                <Popover.Content>
                                                  <div>
                                                    <p className="mb-1">
                                                      <strong>{t('BOM.BOM_SUGGESTION_CARD.APPROVED_BY')}&nbsp;</strong>
                                                      {item.approvedRejectedBy?.firstName} {item.approvedRejectedBy?.lastName}
                                                    </p>
                                                    <p className="mb-1">
                                                      <strong>{t('BOM.BOM_SUGGESTION_CARD.APPROVED_AT')}&nbsp;</strong>
                                                      {moment(item.approvedRejectedAt).format('DD-MMMM-YYYY hh:mm A')}
                                                    </p>
                                                    <p className="mb-0">
                                                      <strong>{t('BOM.BOM_SUGGESTION_CARD.COMMENT')}&nbsp;</strong>
                                                      {item?.comment}
                                                    </p>
                                                  </div>
                                                </Popover.Content>
                                              </Popover>
                                            }
                                          >
                                            <i className="icon icon-Information f-20" />
                                          </OverlayTrigger>
                                        </>
                                      )}
                                    </span>
                                  )}
                                </span>
                              </li>
                            </ul>
                            {item?.subBomList && item.subBomList.length > 0 && (
                              <div className="collapse-card add-bom-accordion mt-3">
                                <Accordion activeKey={subBomAccordionKeys[`new-${item._id}`] !== undefined ? subBomAccordionKeys[`new-${item._id}`] : '0'}>
                                  <Card className="bom-add-card">
                                    <Card.Header>
                                      <div className="d-flex align-items-center">
                                        <label className="switch-text mb-0 ml-16 f-16 text-bold">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.SUB_BOM')}</label>
                                        <Accordion.Toggle
                                          className="btn-toggle accordion-toggle-icon"
                                          as={Button}
                                          variant="link"
                                          eventKey="0"
                                          onClick={() =>
                                            setSubBomAccordionKeys((prev) => ({
                                              ...prev,
                                              [`new-${item._id}`]: prev[`new-${item._id}`] === '0' ? null : '0',
                                            }))
                                          }
                                        >
                                          <CustomToggle eventKey="0" />
                                        </Accordion.Toggle>
                                      </div>
                                    </Card.Header>
                                    <Accordion.Collapse eventKey="0">
                                      <Card.Body className="accordion-new-body">{renderSubBomListTable(item.subBomList, false)}</Card.Body>
                                    </Accordion.Collapse>
                                  </Card>
                                </Accordion>
                              </div>
                            )}
                            {item?.productImpact && (
                              <div className="collapse-card add-bom-accordion mt-3">
                                <Accordion
                                  activeKey={productImpactActiveKeys[`new-${item._id}`] !== undefined ? productImpactActiveKeys[`new-${item._id}`] : '0'}
                                >
                                  <Card className="bom-add-card">
                                    <Card.Header>
                                      <span className="bom-subheader text-bold">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.BOM_PRODUCT_IMPACT')}</span>
                                      <Accordion.Toggle
                                        className="btn-toggle accordion-toggle-icon"
                                        as={Button}
                                        variant="link"
                                        eventKey="0"
                                        onClick={() =>
                                          setProductImpactActiveKeys((prev) => ({
                                            ...prev,
                                            [`new-${item._id}`]: prev[`new-${item._id}`] === '0' ? null : '0',
                                          }))
                                        }
                                      >
                                        <CustomToggle eventKey="0" />
                                      </Accordion.Toggle>
                                    </Card.Header>
                                    <Accordion.Collapse eventKey="0">
                                      <Card.Body className="p-3">{renderProductImpact(item?.productImpact, false, null, {})}</Card.Body>
                                    </Accordion.Collapse>
                                  </Card>
                                </Accordion>
                              </div>
                            )}
                            {setBomStatus(item)}
                          </Card.Body>
                        </Card>
                      </Col>
                    );
                  })}

                {!suggestionData?.bomComponents && suggestionData?.bomComponents.length === 0 && (
                  <Col md={12}>
                    <p className="text-center">{t('BOM.BOM_SUGGESTION_CARD.NO_BOM_COMPONET_FOUND')}</p>
                  </Col>
                )}
              </Row>
            )}

            {suggestionType === 'amendment' && (
              <>
                {suggestionDataAsOriginal?.length > 0 && (
                  <>
                    {suggestionDataAsOriginal.map((item, i) => {
                      const oldData = Array.isArray(oldSuggestion) && oldSuggestion.filter((e) => e._id === item._id);
                      const isBomDescription = setExistingData(item.bomLibId, item?.bomDescription, '', fieldsArray[0]);
                      const isBOMSupplier = setExistingData(item.bomLibId, item?.BOMSupplier.name, '', fieldsArray[1]);
                      const isComposition = setExistingData(item.bomLibId, item?.composition, '', fieldsArray[2]);
                      const isSize = setExistingData(item.bomLibId, item?.size, item?.sizeUnitOfMeasure?.name, fieldsArray[3]);
                      const isWeight = setExistingData(item.bomLibId, item?.weight, item?.weightUnitOfMeasure?.name, fieldsArray[4]);
                      const isPlacement = setExistingData(item.bomLibId, item?.newPlacement, null, fieldsArray[6]);
                      const isAdditionalInfo = setExistingData(item.bomLibId, item?.additionalInfo, '', fieldsArray[7]);
                      const isTransport = setExistingData(item.bomLibId, item?.transport, null, fieldsArray[8]);
                      const isBomCompType = setExistingData(item.bomLibId, item?.bomComponentSubType, null, fieldsArray[9]);
                      const isFinish = setExistingData(item.bomLibId, item?.finished, null, fieldsArray[11]);
                      const isDynamic = setExistingData(item.bomLibId, item?.dynamicColumn, null, fieldsArray[12]);
                      const isPricePerUnit = setExistingData(
                        item.bomLibId,
                        item?.pricePerUnit,
                        item?.pricePerUnitCurrency?.value || item?.pricePerUnitCurrency,
                        fieldsArray[15],
                      );
                      const getClassNameForSize = () => {
                        if (item?.keysActuallyChanged?.includes('size') && item?.status === 'Approved') {
                          return approvedFromSupplierToDo;
                        }
                        console.log('test data.......', isSize);
                        if (isSize) {
                          return bomStatusApprovedClass;
                        }
                        return '';
                      };
                      const getClassNameForQuantity = () => {
                        if (item?.keysActuallyChanged?.includes('quantity') && item?.status === 'Approved') {
                          return approvedFromSupplierToDo;
                        }
                        if (isQuantity) {
                          return bomStatusApprovedClass;
                        }
                        return '';
                      };
                      const getClassNameForPricePerUnit = () => {
                        if (item?.keysActuallyChanged?.includes('pricePerUnit') && item?.status === 'Approved') {
                          return approvedFromSupplierToDo;
                        }
                        if (item?.status === 'Approved') {
                          return '';
                        }
                        if (isPricePerUnit && item?.pricePerUnit) {
                          return bomStatusApprovedClass;
                        }
                        return '';
                      };

                      const getClassNameForAdditionalInfo = () => {
                        if (item?.keysActuallyChanged?.includes('additionalInfo') && item?.status === 'Approved') {
                          return approvedFromSupplierToDo;
                        }
                        if (isAdditionalInfo) {
                          return bomStatusApprovedClass;
                        }
                        return '';
                      };

                      const getClassNameForWeight = () => {
                        if (item?.keysActuallyChanged?.includes('weight') && item?.status === 'Approved') {
                          return approvedFromSupplierToDo;
                        }
                        if (isWeight && item?.weight) {
                          return bomStatusApprovedClass;
                        }
                        return '';
                      };
                      const getClassNameForBomDescription = () => {
                        if (item?.keysActuallyChanged?.includes('bomDescription') && item?.status === 'Approved') {
                          return approvedFromSupplierToDo;
                        }
                        if (isBomDescription && item?.bomDescription) {
                          return bomStatusApprovedClass;
                        }
                        return '';
                      };
                      const getClassNameForNewPlacement = () => {
                        if (item?.status === 'Approved') {
                          if (item?.autoApproved || item?.keysActuallyChanged?.includes('newPlacement')) {
                            return bomStatusApprovedClass;
                          }
                          return '';
                        }
                        if (isPlacement && item?.newPlacement) {
                          return bomStatusApprovedClass;
                        }
                        return '';
                      };
                      const getClassNameForTransport = () => {
                        if (item?.keysActuallyChanged?.includes('transport') && item?.status === 'Approved') {
                          return approvedFromSupplierToDo;
                        }
                        if (isTransport && item?.transport) {
                          return bomStatusApprovedClass;
                        }
                        return '';
                      };
                      const getClassNameForDynamicColomn = (colId) => {
                        if (!colId) return '';
                        if (!isDynamic || !Array.isArray(isDynamic) || isDynamic.length === 0) return '';
                        const colIdStr = colId?.toString ? colId.toString() : String(colId);
                        const isFieldUpdated = isDynamic.some((changed) => {
                          if (!changed) return false;
                          let changedColId = null;
                          if (changed.colId) {
                            changedColId = typeof changed.colId === 'object' ? changed.colId._id || changed.colId : changed.colId;
                          } else if (changed._id) {
                            changedColId = changed._id;
                          }
                          if (!changedColId) return false;
                          const changedColIdStr = changedColId?.toString ? changedColId.toString() : String(changedColId);
                          return changedColIdStr === colIdStr;
                        });
                        if (isFieldUpdated && item?.keysActuallyChanged?.includes('dynamicColumn') && item?.status === 'Approved') {
                          return approvedFromSupplierToDo;
                        }
                        if (isFieldUpdated) {
                          return bomStatusApprovedClass;
                        }
                        return '';
                      };

                      const getClassNameForFinish = () => {
                        if (item?.keysActuallyChanged?.includes('finished') && item?.status === 'Approved') {
                          return approvedFromSupplierToDo;
                        }
                        if (isFinish && item?.finished) {
                          return bomStatusApprovedClass;
                        }
                        return '';
                      };
                      const getClassNameForBOMSubCompType = () => {
                        if (item?.keysActuallyChanged?.includes('bomComponentSubType') && item?.status === 'Approved') {
                          return approvedFromSupplierToDo;
                        }
                        if (isBomCompType && item?.bomComponentSubType) {
                          return bomStatusApprovedClass;
                        }
                        return '';
                      };
                      const isSubBomList = setExistingData(item.bomLibId, item?.subBomList, null, fieldsArray[13]);
                      const isProductImpact = setExistingData(item.bomLibId, item?.productImpact, null, fieldsArray[14]);
                      const getClassNameForSubBomList = () => {
                        if (item?.keysActuallyChanged?.includes('subBomList') && item?.status === 'Approved') {
                          return approvedFromSupplierToDo;
                        }
                        if (isSubBomList && item?.subBomList) {
                          return bomStatusApprovedClass;
                        }
                        return '';
                      };
                      const getClassNameForProductImpact = () => {
                        if (item?.keysActuallyChanged?.includes('productImpact') && item?.status === 'Approved') {
                          return approvedFromSupplierToDo;
                        }
                        if (item?.status === 'Approved') {
                          return '';
                        }
                        if (isProductImpact && item?.productImpact) {
                          return bomStatusApprovedClass;
                        }
                        return '';
                      };
                      return (
                        <Row key={`row${item?._id}`}>
                          {/* Original Entry card */}
                          {item.status === 'Approved' ? (
                            <Col md={6}>
                              <Card key={item?._id} className="rounded-0 mb-2 card-bordered">
                                <Card.Header className="py-2 px-3">
                                  <div className="d-flex justify-content-between align-items-center">
                                    <div>{t('BOM.BOM_SUGGESTION_CARD.ORIGINAL_ENTRY')}</div>
                                  </div>
                                </Card.Header>
                                <Card.Body className="py-2 px-3">
                                  <ul className="suggestion-item">
                                    {suggestionType === 'amendment' && (
                                      <li>
                                        <strong>{t('BOM.BOM_SUGGESTION_CARD.PRODUCT_REFS')}&nbsp;</strong>
                                        {item.originalItem.devOrderId?.number}
                                      </li>
                                    )}

                                    <li>
                                      <strong>{t('BOM.BOM_SUGGESTION_CARD.COMPONENT_CODE')}&nbsp;</strong>
                                      {item.originalItem?.referenceCode}
                                    </li>
                                    <li>
                                      <strong>{t('BOM.BOM_SUGGESTION_CARD.COMPONENT_TYPE')}&nbsp;</strong>
                                      {item.originalItem.bomSubType?.name}
                                    </li>
                                    <li>
                                      <strong>{t('BOM.BOM_SUGGESTION_CARD.COMPONENT_DESCRIPTION')}&nbsp;</strong>
                                      <span>{item.originalItem?.bomDescription}</span>
                                    </li>
                                    <li>
                                      <strong>{t('BOM.BOM_SUGGESTION_CARD.COMPONENT_SUPLIER')}&nbsp;</strong>
                                      <span>{item.originalItem?.BOMSupplier?.name}</span>
                                    </li>
                                    <li>
                                      <strong>{t('BOM.BOM_SUGGESTION_CARD.COMPOSITIONES')}&nbsp;</strong>
                                      <span>
                                        {shortenStringWithTooltip(
                                          item?.originalItem?.composition
                                            ?.map((_el) =>
                                              _el?.percentage && _el?.percentage > 0 ? `${_el?.percentage}% ${_el?.composition?.name || ''}` : '',
                                            )
                                            .sort((a, b) => b.percentage - a.percentage)
                                            .join(', '),
                                          20,
                                        )}
                                      </span>
                                    </li>
                                    <li>
                                      <strong>{t('BOM.BOM_SUGGESTION_CARD.SIZE')}&nbsp;</strong>
                                      <span>
                                        {item.originalItem?.size} {item.originalItem?.sizeUnitOfMeasure?.name}
                                      </span>
                                    </li>
                                    <li>
                                      <strong>{t('BOM.BOM_SUGGESTION_CARD.WEIGHT')}&nbsp;</strong>
                                      <span>
                                        {item.originalItem?.weight} {item.originalItem?.weightUnitOfMeasure?.name}
                                      </span>
                                    </li>

                                    <li>
                                      <strong>{t('BOM.BOM_SUGGESTION_CARD.PRICE_PER_UNIT')}&nbsp;</strong>
                                      <span>
                                        {item.originalItem?.pricePerUnit || ''}{' '}
                                        {typeof item.originalItem?.pricePerUnitCurrency === 'string'
                                          ? item.originalItem?.pricePerUnitCurrency
                                          : item.originalItem?.pricePerUnitCurrency?.label || item.originalItem?.pricePerUnitCurrency?.value || ''}
                                      </span>
                                    </li>
                                    <li>
                                      <strong>{t('BOM.BOM_SUGGESTION_CARD.PLACEMENT')}&nbsp;</strong>
                                      <span>{item?.originalItem?.newPlacement?.map((items) => items.name)?.join(', ')}</span>
                                    </li>
                                    <li>
                                      <strong>{`${t(bomTransport)}:`}&nbsp;</strong>
                                      <span>{item?.originalItem?.transport?.label}</span>
                                    </li>
                                    <li>
                                      <strong>{`${t(bomCompSubType)}:`}&nbsp;</strong>
                                      <span>{item?.originalItem?.bomComponentSubType?.name}</span>
                                    </li>
                                    <li>
                                      <strong>{`${t(bomFinished)}:`}&nbsp;</strong>
                                      <span>{item?.originalItem?.finished?.name}</span>
                                    </li>

                                    <li>
                                      <strong>{t('BOM.BOM_SUGGESTION_CARD.ADDITIONAL_INFO')}&nbsp;</strong>
                                      <span>{item.originalItem?.additionalInfo}</span>
                                    </li>
                                    {item?.originalItem?.dynamicColumn?.map((field, index) => {
                                      const keyName = field?.colId?.keyName;
                                      const type = field?.colId?.type;
                                      let value;
                                      if (type === 'Multi Dropdown') {
                                        value = Array.isArray(field?.valueId) ? field.valueId.map((v) => v.keyName).join(', ') : '';
                                      } else if (type === 'dropdown') {
                                        value = field?.valueId?.keyName || '';
                                      } else {
                                        value = field?.valueText || '';
                                      }

                                      return (
                                        <li key={index}>
                                          <strong>{keyName}: </strong>
                                          <span>{value}</span>
                                        </li>
                                      );
                                    })}
                                  </ul>
                                  {item?.originalItem?.subBomList && item.originalItem.subBomList.length > 0 && (
                                    <div className="collapse-card add-bom-accordion mt-3">
                                      <Accordion
                                        activeKey={
                                          subBomAccordionKeys[`original-${item._id}`] !== undefined ? subBomAccordionKeys[`original-${item._id}`] : '0'
                                        }
                                      >
                                        <Card className="bom-add-card">
                                          <Card.Header>
                                            <div className="d-flex align-items-center">
                                              <label className="switch-text mb-0 ml-16 f-16 text-bold">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.SUB_BOM')}</label>
                                              <Accordion.Toggle
                                                className="btn-toggle accordion-toggle-icon"
                                                as={Button}
                                                variant="link"
                                                eventKey="0"
                                                onClick={() =>
                                                  setSubBomAccordionKeys((prev) => ({
                                                    ...prev,
                                                    [`original-${item._id}`]: prev[`original-${item._id}`] === '0' ? null : '0',
                                                  }))
                                                }
                                              >
                                                <CustomToggle eventKey="0" />
                                              </Accordion.Toggle>
                                            </div>
                                          </Card.Header>
                                          <Accordion.Collapse eventKey="0">
                                            <Card.Body className="accordion-new-body">{renderSubBomListTable(item.originalItem.subBomList, false)}</Card.Body>
                                          </Accordion.Collapse>
                                        </Card>
                                      </Accordion>
                                    </div>
                                  )}
                                  {item?.originalItem?.productImpact && (
                                    <div className="collapse-card add-bom-accordion mt-3">
                                      <Accordion
                                        activeKey={
                                          productImpactActiveKeys[`original-${item._id}`] !== undefined ? productImpactActiveKeys[`original-${item._id}`] : '0'
                                        }
                                      >
                                        <Card className="bom-add-card">
                                          <Card.Header>
                                            <span className="bom-subheader text-bold">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.BOM_PRODUCT_IMPACT')}</span>
                                            <Accordion.Toggle
                                              className="btn-toggle accordion-toggle-icon"
                                              as={Button}
                                              variant="link"
                                              eventKey="0"
                                              onClick={() =>
                                                setProductImpactActiveKeys((prev) => ({
                                                  ...prev,
                                                  [`original-${item._id}`]: prev[`original-${item._id}`] === '0' ? null : '0',
                                                }))
                                              }
                                            >
                                              <CustomToggle eventKey="0" />
                                            </Accordion.Toggle>
                                          </Card.Header>
                                          <Accordion.Collapse eventKey="0">
                                            <Card.Body className="p-3">{renderProductImpact(item?.originalItem?.productImpact, false, null, {})}</Card.Body>
                                          </Accordion.Collapse>
                                        </Card>
                                      </Accordion>
                                    </div>
                                  )}
                                </Card.Body>
                              </Card>
                            </Col>
                          ) : (
                            item?.status !== 'Deleted' && (
                              <Col md={6}>
                                {Array.isArray(oldData) &&
                                  oldData
                                    .filter((oldItem) => oldItem.status !== 'Approved')
                                    .map((oldItem) => (
                                      <Card key={oldItem?._id} className="rounded-0 mb-2 card-bordered">
                                        <Card.Header className="py-2 px-3">
                                          <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                              <strong>{t('BOM.BOM_SUGGESTION_CARD.ORIGINAL_ENTRY')}</strong>
                                            </div>
                                          </div>
                                        </Card.Header>
                                        <Card.Body className="py-2 px-3">
                                          <ul className="suggestion-item">
                                            {suggestionData.type === 'amendment' && (
                                              <li>
                                                <strong>{t('BOM.BOM_SUGGESTION_CARD.PRODUCT_REF')}&nbsp;</strong>
                                                {oldItem.devOrderId?.number}
                                              </li>
                                            )}

                                            <li>
                                              <strong>{t('BOM.BOM_SUGGESTION_CARD.COMPONENT_CODE')}&nbsp;</strong>
                                              {oldItem?.referenceCode}
                                            </li>
                                            <li>
                                              <strong>{t('BOM.BOM_SUGGESTION_CARD.COMPONENT_TYPE')}&nbsp;</strong>
                                              {oldItem.bomSubType?.name}
                                            </li>
                                            <li>
                                              <strong>{t('BOM.BOM_SUGGESTION_CARD.COMPONENT_DESCRIPTION')}&nbsp;</strong>
                                              <span>{oldItem?.bomDescription}</span>
                                            </li>
                                            <li>
                                              <strong>{t('BOM.BOM_SUGGESTION_CARD.COMPONENT_SUPLIER')}&nbsp;</strong>
                                              <span>{oldItem?.BOMSupplier.name}</span>
                                            </li>
                                            <li>
                                              <strong>{t('BOM.BOM_SUGGESTION_CARD.COMPOSITION')}&nbsp;</strong>
                                              <span>
                                                {oldItem?.composition
                                                  ?.map((el2) =>
                                                    el2?.percentage && el2?.percentage > 0 ? `${el2?.percentage}% ${el2?.composition?.name || ''}` : '',
                                                  )
                                                  .sort((a, b) => b.percentage - a.percentage)
                                                  .join(', ')}
                                              </span>
                                            </li>
                                            <li>
                                              <strong> {t('BOM.BOM_SUGGESTION_CARD.SIZE')}&nbsp;</strong>
                                              <span>
                                                {oldItem?.size} {oldItem?.sizeUnitOfMeasure?.name}
                                              </span>
                                            </li>
                                            <li>
                                              <strong>{t('BOM.BOM_SUGGESTION_CARD.WEIGHT')}&nbsp;</strong>
                                              <span>
                                                {oldItem?.weight} {oldItem?.weightUnitOfMeasure?.name}
                                              </span>
                                            </li>

                                            <li>
                                              <strong>{t('BOM.BOM_SUGGESTION_CARD.PRICE_PER_UNIT')}&nbsp;</strong>
                                              <span>
                                                {oldItem?.pricePerUnit || ''}{' '}
                                                {typeof oldItem?.pricePerUnitCurrency === 'string'
                                                  ? oldItem?.pricePerUnitCurrency
                                                  : oldItem?.pricePerUnitCurrency?.label || oldItem?.pricePerUnitCurrency?.value || ''}
                                              </span>
                                            </li>
                                            <li>
                                              <strong>{t('BOM.BOM_SUGGESTION_CARD.PLACEMENT')}&nbsp;</strong>
                                              <span>{oldItem?.newPlacement?.map((items) => items.name)?.join(', ')}</span>
                                            </li>
                                            <li>
                                              <strong>{`${t(bomTransport)}:`}&nbsp;</strong>
                                              <span>{oldItem?.transport?.label}</span>
                                            </li>
                                            <li>
                                              <strong>{`${t(bomCompSubType)}:`}&nbsp;</strong>
                                              <span>{item?.bomComponentSubType?.name}</span>
                                            </li>
                                            <li>
                                              <strong>{`${t(bomFinished)}:`}&nbsp;</strong>
                                              <span>{item?.finished?.name}</span>
                                            </li>
                                            <li>
                                              <strong>{t('BOM.BOM_SUGGESTION_CARD.ADDITIONAL_INFO')}&nbsp;</strong>
                                              <span>{oldItem?.additionalInfo}</span>
                                            </li>
                                            {oldItem?.dynamicColumn
                                              ?.filter((field) => field?.colId?.isActive !== false)
                                              .map((field, index) => {
                                                const keyName = field?.colId?.keyName;
                                                const type = field?.colId?.type;
                                                const colId = field?.colId?._id;
                                                let value;
                                                if (type === 'Multi Dropdown') {
                                                  value = Array.isArray(field?.valueId) ? field.valueId.map((v) => v?.keyName).join(', ') : '';
                                                } else if (type === 'dropdown') {
                                                  value = field?.valueId?.keyName || '';
                                                } else {
                                                  value = field?.valueText || '';
                                                }
                                                return (
                                                  <li key={index}>
                                                    <strong>{keyName}: </strong>
                                                    <span>{value}</span>
                                                  </li>
                                                );
                                              })}

                                            {oldItem?.comment && (
                                              <li>
                                                <strong>{t('BOM.BOM_SUGGESTION_CARD.COMMENT')}&nbsp;</strong>
                                                <span>{shortenStringWithTooltip(oldItem?.comment, 35)}</span>
                                              </li>
                                            )}
                                          </ul>
                                          {oldItem?.subBomList && oldItem.subBomList.length > 0 && (
                                            <div className="collapse-card add-bom-accordion mt-3">
                                              <Accordion
                                                activeKey={
                                                  subBomAccordionKeys[`old-${oldItem._id}`] !== undefined ? subBomAccordionKeys[`old-${oldItem._id}`] : '0'
                                                }
                                              >
                                                <Card className="bom-add-card">
                                                  <Card.Header>
                                                    <div className="d-flex align-items-center">
                                                      <label className="switch-text mb-0 ml-16 f-16 text-bold">
                                                        {t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.SUB_BOM')}
                                                      </label>
                                                      <Accordion.Toggle
                                                        className="btn-toggle accordion-toggle-icon"
                                                        as={Button}
                                                        variant="link"
                                                        eventKey="0"
                                                        onClick={() =>
                                                          setSubBomAccordionKeys((prev) => ({
                                                            ...prev,
                                                            [`old-${oldItem._id}`]: prev[`old-${oldItem._id}`] === '0' ? null : '0',
                                                          }))
                                                        }
                                                      >
                                                        <CustomToggle eventKey="0" />
                                                      </Accordion.Toggle>
                                                    </div>
                                                  </Card.Header>
                                                  <Accordion.Collapse eventKey="0">
                                                    <Card.Body className="accordion-new-body">{renderSubBomListTable(oldItem.subBomList, false)}</Card.Body>
                                                  </Accordion.Collapse>
                                                </Card>
                                              </Accordion>
                                            </div>
                                          )}
                                          {oldItem?.productImpact && (
                                            <div className="collapse-card add-bom-accordion mt-3">
                                              <Accordion
                                                activeKey={
                                                  productImpactActiveKeys[`old-${oldItem._id}`] !== undefined
                                                    ? productImpactActiveKeys[`old-${oldItem._id}`]
                                                    : '0'
                                                }
                                              >
                                                <Card className="bom-add-card">
                                                  <Card.Header>
                                                    <span className="bom-subheader text-bold">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.BOM_PRODUCT_IMPACT')}</span>
                                                    <Accordion.Toggle
                                                      className="btn-toggle accordion-toggle-icon"
                                                      as={Button}
                                                      variant="link"
                                                      eventKey="0"
                                                      onClick={() =>
                                                        setProductImpactActiveKeys((prev) => ({
                                                          ...prev,
                                                          [`old-${oldItem._id}`]: prev[`old-${oldItem._id}`] === '0' ? null : '0',
                                                        }))
                                                      }
                                                    >
                                                      <CustomToggle eventKey="0" />
                                                    </Accordion.Toggle>
                                                  </Card.Header>
                                                  <Accordion.Collapse eventKey="0">
                                                    <Card.Body className="p-3">{renderProductImpact(oldItem?.productImpact, false, null, {})}</Card.Body>
                                                  </Accordion.Collapse>
                                                </Card>
                                              </Accordion>
                                            </div>
                                          )}
                                        </Card.Body>
                                      </Card>
                                    ))}
                              </Col>
                            )
                          )}
                          <Col md={6}>
                            <Card key={i} className="rounded-0 mb-2 card-bordered">
                              <Card.Header className="py-2 px-3">
                                <div className="d-flex align-items-center">
                                  <div>
                                    <strong>{t('BOM.BOM_SUGGESTION_CARD.SUGGESTION_AMENDENT')}</strong>
                                  </div>
                                  {userInfo.role !== 'Supplier' && (item.status === 'Pending' || item.status === 'Rejected') && (
                                    <div className="common-checkbox ml-auto">
                                      <input
                                        onChange={(e) => {
                                          onCheck(e, item._id);
                                        }}
                                        name={`check_${i}`}
                                        id={`check_${i}`}
                                        type="checkbox"
                                        disabled={checkBoxDisabled}
                                        checked={some(selectedIdArray, {
                                          _id: item?._id,
                                        })}
                                      />
                                      <label htmlFor={`check_${i}`} className="chklabel" />
                                    </div>
                                  )}
                                </div>
                              </Card.Header>
                              <Card.Body className="py-2 px-3">
                                <ul className="suggestion-item">
                                  {suggestionData.type === 'amendment' && (
                                    <li>
                                      <strong>{t('BOM.BOM_SUGGESTION_CARD.PRODUCT_REF')}&nbsp;</strong>
                                      {item.devOrderId?.number}
                                    </li>
                                  )}
                                  <li>
                                    <strong>{t('BOM.BOM_SUGGESTION_CARD.CODE_COMPONENT')}&nbsp;</strong>
                                    {item?.referenceCode}
                                  </li>
                                  <li>
                                    <strong>{t('BOM.BOM_SUGGESTION_CARD.TYPE_COMPONENT')}&nbsp;</strong>
                                    {item.bomSubType?.name}
                                  </li>
                                  <li>
                                    <strong>{t('BOM.BOM_SUGGESTION_CARD.DESCRPTION_COMPONENT')}&nbsp;</strong>
                                    <span className={getClassNameForBomDescription()}>
                                      {item?.bomDescription}
                                      &nbsp;
                                      {item?.keysActuallyChanged?.includes('bomDescription') &&
                                        item?.status === 'Approved' &&
                                        item.autoApproved &&
                                        autoApproved}
                                    </span>
                                  </li>
                                  <li>
                                    <strong>{t('BOM.BOM_SUGGESTION_CARD.SUPLIER_COMPONENT')}&nbsp;</strong>
                                    <span className={isBOMSupplier ? bomStatusApprovedClass : ''}>{item?.BOMSupplier.name}</span>
                                  </li>
                                  <li>
                                    <strong>{t('BOM.BOM_SUGGESTION_CARD.COMPOSITION')}&nbsp;</strong>
                                    <span
                                      className={
                                        item?.keysActuallyChanged?.includes('composition') && item?.status === 'Approved'
                                          ? approvedFromSupplierToDo
                                          : approvedStatus(isComposition)
                                      }
                                    >
                                      {item?.composition
                                        ?.map((el3) => (el3?.percentage && el3?.percentage > 0 ? `${el3?.percentage}% ${el3?.composition?.name || ''}` : ''))
                                        .sort((a, b) => b.percentage - a.percentage)
                                        .join(', ')}
                                      &nbsp;
                                      {item?.keysActuallyChanged?.includes('composition') && item?.status === 'Approved' && item.autoApproved && autoApproved}
                                    </span>
                                  </li>
                                  <li>
                                    <strong>{t('BOM.BOM_SUGGESTION_CARD.BOM_SIZE')}&nbsp;</strong>
                                    <span className={getClassNameForSize()}>
                                      {item?.size}
                                      {item?.sizeUnitOfMeasure?.name}
                                      &nbsp;
                                      {item?.keysActuallyChanged?.includes('size') && item?.status === 'Approved' && item.autoApproved && autoApproved}
                                    </span>
                                  </li>
                                  <li>
                                    <strong>{t('BOM.BOM_SUGGESTION_CARD.BOM_WEIGHT')}&nbsp;</strong>
                                    <span className={getClassNameForWeight()}>
                                      {item?.weight} {item?.weightUnitOfMeasure?.name}
                                      &nbsp;
                                      {item?.keysActuallyChanged?.includes('weight') && item?.status === 'Approved' && item.autoApproved && autoApproved}
                                    </span>
                                  </li>

                                  <li>
                                    <strong>{t('BOM.BOM_SUGGESTION_CARD.PRICE_PER_UNIT')}&nbsp;</strong>
                                    <span className={getClassNameForPricePerUnit()}>
                                      {item?.pricePerUnit || ''}{' '}
                                      {typeof item?.pricePerUnitCurrency === 'string'
                                        ? item?.pricePerUnitCurrency
                                        : item?.pricePerUnitCurrency?.label || item?.pricePerUnitCurrency?.value || ''}
                                      &nbsp;
                                      {item?.keysActuallyChanged?.includes('pricePerUnit') && item?.status === 'Approved' && item.autoApproved && autoApproved}
                                    </span>
                                  </li>
                                  <li>
                                    <strong>{t('BOM.BOM_SUGGESTION_CARD.BOM_PLACEMENT')}&nbsp;</strong>
                                    <span className={getClassNameForNewPlacement()}>
                                      {item?.newPlacement?.map((items) => items.name)?.join(', ')}
                                      {item?.keysActuallyChanged?.includes('newPlacement') && item?.status === 'Approved' && item.autoApproved && autoApproved}
                                    </span>
                                  </li>
                                  <li>
                                    <strong>{`${t(bomTransport)}:`}&nbsp;</strong>
                                    <span className={getClassNameForTransport()}>
                                      {item?.transport?.label}
                                      {item?.keysActuallyChanged?.includes('transport') && item?.status === 'Approved' && item.autoApproved && autoApproved}
                                    </span>
                                  </li>
                                  <li>
                                    <strong>{`${t(bomCompSubType)}:`}&nbsp;</strong>
                                    <span className={getClassNameForBOMSubCompType()}>
                                      {item?.bomComponentSubType?.name}
                                      {item?.keysActuallyChanged?.includes('bomComponentSubType') &&
                                        item?.status === 'Approved' &&
                                        item.autoApproved &&
                                        autoApproved}
                                    </span>
                                  </li>
                                  <li>
                                    <strong>{`${t(bomFinished)}:`}&nbsp;</strong>
                                    <span className={getClassNameForFinish()}>
                                      {item?.finished?.name}
                                      {item?.keysActuallyChanged?.includes('finished') && item?.status === 'Approved' && item.autoApproved && autoApproved}
                                    </span>
                                  </li>
                                  <li>
                                    <strong>{t('BOM.BOM_SUGGESTION_CARD.BOM_ADDITIONAL_INFO')}&nbsp;</strong>
                                    <span className={getClassNameForAdditionalInfo()}>{item?.additionalInfo}</span>
                                  </li>

                                  {item?.dynamicColumn
                                    ?.filter((dynamicItem) => dynamicItem?.colId?.isActive !== false)
                                    .map((dynamicItem, index) => {
                                      const keyName = dynamicItem?.colId?.keyName;
                                      const type = dynamicItem?.colId?.type;
                                      const colId = dynamicItem?.colId?._id;

                                      let value = '';
                                      if (type === 'Multi Dropdown') {
                                        value = Array.isArray(dynamicItem?.valueId) ? dynamicItem.valueId.map((v) => v?.keyName).join(', ') : '';
                                      } else if (type === 'dropdown') {
                                        value = dynamicItem?.valueId?.keyName || '';
                                      } else {
                                        value = dynamicItem?.valueText || '';
                                      }

                                      return (
                                        <li key={index}>
                                          <strong>{keyName}: </strong>
                                          <span className={getClassNameForDynamicColomn(colId)}>
                                            {value}
                                            {(() => {
                                              if (!Array.isArray(isDynamic) || isDynamic.length === 0 || !colId) return false;
                                              const colIdStr = colId?.toString ? colId.toString() : String(colId);
                                              const isFieldUpdated = isDynamic.some((changed) => {
                                                if (!changed) return false;
                                                let changedColId = null;
                                                if (changed.colId) {
                                                  changedColId = typeof changed.colId === 'object' ? changed.colId._id || changed.colId : changed.colId;
                                                } else if (changed._id) {
                                                  changedColId = changed._id;
                                                }
                                                if (!changedColId) return false;
                                                const changedColIdStr = changedColId?.toString ? changedColId.toString() : String(changedColId);
                                                return changedColIdStr === colIdStr;
                                              });
                                              return (
                                                isFieldUpdated &&
                                                item?.keysActuallyChanged?.includes('dynamicColumn') &&
                                                item?.status === 'Approved' &&
                                                item.autoApproved &&
                                                autoApproved
                                              );
                                            })()}
                                          </span>
                                        </li>
                                      );
                                    })}
                                </ul>
                                {item?.subBomList && item.subBomList.length > 0 && (
                                  <div className="collapse-card add-bom-accordion mt-3">
                                    <Accordion
                                      activeKey={
                                        subBomAccordionKeys[`suggestion-${item._id}`] !== undefined ? subBomAccordionKeys[`suggestion-${item._id}`] : '0'
                                      }
                                    >
                                      <Card className="bom-add-card">
                                        <Card.Header>
                                          <div className="d-flex align-items-center">
                                            <label className={`switch-text mb-0 ml-16 f-16 text-bold ${getClassNameForSubBomList()}`}>
                                              {t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.SUB_BOM')}
                                              {item?.keysActuallyChanged?.includes('subBomList') &&
                                                item?.status === 'Approved' &&
                                                item.autoApproved &&
                                                ` ${autoApproved}`}
                                            </label>
                                            <Accordion.Toggle
                                              className="btn-toggle accordion-toggle-icon"
                                              as={Button}
                                              variant="link"
                                              eventKey="0"
                                              onClick={() =>
                                                setSubBomAccordionKeys((prev) => ({
                                                  ...prev,
                                                  [`suggestion-${item._id}`]: prev[`suggestion-${item._id}`] === '0' ? null : '0',
                                                }))
                                              }
                                            >
                                              <CustomToggle eventKey="0" />
                                            </Accordion.Toggle>
                                          </div>
                                        </Card.Header>
                                        <Accordion.Collapse eventKey="0">
                                          <Card.Body className="accordion-new-body">
                                            {renderSubBomListTable(
                                              item.subBomList,
                                              !!isSubBomList,
                                              item?.status,
                                              Array.isArray(isSubBomList) ? isSubBomList : [],
                                            )}
                                          </Card.Body>
                                        </Accordion.Collapse>
                                      </Card>
                                    </Accordion>
                                  </div>
                                )}
                                {item?.productImpact && (
                                  <div className="collapse-card add-bom-accordion mt-3">
                                    <Accordion
                                      activeKey={
                                        productImpactActiveKeys[`suggestion-${item._id}`] !== undefined
                                          ? productImpactActiveKeys[`suggestion-${item._id}`]
                                          : '0'
                                      }
                                    >
                                      <Card className="bom-add-card">
                                        <Card.Header>
                                          <div className="d-flex align-items-center">
                                            <label className={`bom-subheader text-bold ${getClassNameForProductImpact()}`}>
                                              {t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.BOM_PRODUCT_IMPACT')}
                                              {item?.keysActuallyChanged?.includes('productImpact') &&
                                                item?.status === 'Approved' &&
                                                item.autoApproved &&
                                                ` ${autoApproved}`}
                                            </label>
                                            <Accordion.Toggle
                                              className="btn-toggle accordion-toggle-icon"
                                              as={Button}
                                              variant="link"
                                              eventKey="0"
                                              onClick={() =>
                                                setProductImpactActiveKeys((prev) => ({
                                                  ...prev,
                                                  [`suggestion-${item._id}`]: prev[`suggestion-${item._id}`] === '0' ? null : '0',
                                                }))
                                              }
                                            >
                                              <CustomToggle eventKey="0" />
                                            </Accordion.Toggle>
                                          </div>
                                        </Card.Header>
                                        <Accordion.Collapse eventKey="0">
                                          <Card.Body className="accordion-new-body">
                                            {renderProductImpact(
                                              item?.productImpact,
                                              !!isProductImpact,
                                              item?.status,
                                              isProductImpact && typeof isProductImpact === 'object' ? isProductImpact : {},
                                            )}
                                          </Card.Body>
                                        </Accordion.Collapse>
                                      </Card>
                                    </Accordion>
                                  </div>
                                )}

                                {setBomStatus(item)}
                              </Card.Body>
                            </Card>
                          </Col>
                        </Row>
                      );
                    })}
                  </>
                )}

                {!suggestionDataAsOriginal && suggestionDataAsOriginal.length === 0 && (
                  <Col md={6}>
                    <p className="text-center">{t('BOM.BOM_SUGGESTION_CARD.NO_DATA_FOUND')}</p>
                  </Col>
                )}
              </>
            )}
          </div>
        )}

        {showApproveRejectPopup && (
          <ConfirmationPopup
            onOpen={showApproveRejectPopup}
            onConfirm={handleApproveReject}
            loading={false}
            title={confirmAction === 'Approved' ? t('SUPPLIER_SUGGESTION.CONFIRM.TITLE_APPROVE') : rejectedTitle}
            message={confirmAction === 'Approved' ? t('SUPPLIER_SUGGESTION.CONFIRM.DELETE_MESSAGE_APPROVE') : rejectedMessage}
            toggle={() => setShowApproveRejectPopup(!showApproveRejectPopup)}
            isCommentOn
            commentText={handleCommentChange}
            comment={approveRejectComment}
          />
        )}
      </div>
      {duplicateCodeModal.isOpen && (
        <DuplicateDeleteModal
          onOpen={duplicateCodeModal.isOpen}
          title={t('BOM.BOM_SUGGESTION_CARD.ERROR_LOG')}
          toggle={() => closeDuplicateDeleteModal()}
          codeItem={duplicateCodeModal?.code}
        />
      )}
    </>
  );
}

export default BomSuggestionCard;
